// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-container {
  display: inline-block;
  min-width: 130px;
}
.toggle-container .toggle-text {
  display: inline-block;
  vertical-align: top;
  margin-top: 5px;
}
.toggle-container .toggle-text.left {
  margin-right: 10px;
}
.toggle-container .toggle-text.right {
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/toggle/toggle.component.less"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,gBAAA;AADF;AADA;EAKI,qBAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAGI;EACE,kBAAA;AADN;AAII;EACE,iBAAA;AAFN","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.toggle-container {\n  display: inline-block;\n  min-width: 130px;\n\n  .toggle-text {\n    display: inline-block;\n    vertical-align: top;\n    margin-top: 5px;\n\n    &.left {\n      margin-right: 10px;\n    }\n\n    &.right {\n      margin-left: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
